module.exports = __webpack_public_path__ + "static/cheese-bread-8bbd317b81fe456615748bbfa456edd2.jpg";